<template>
    <div class="row" style="margin-bottom: 21px;">
        <div class="col-12 col-lg-12">
            <div class="collapse-margin collapse-icon" id="accordionExample">
                <div class="card" style="margin-bottom: 21px;">
                    <div class="card-header collapsed" id="headingTwo" data-toggle="collapse" role="button" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo" style="text-align: center !important;position: relative;height: 50px;">
                        <h5 class="text-primary" style="text-align:center;position: absolute; left: 50%; top: 10px;-webkit-transform: translate(-50%,0%); -moz-transform: translate(-50%,0%); -o-transform: translate(-50%,0%);
                        transform: translate(-50%,0%);">
                        Your Creditfixrr Path to Success
                    </h5>
                    </div>
                    <!-- <div class="mt-3">
                        <h4 class="text-primary" style="text-align:center;">Your Creditfixrr Path to Success</h4>
                    </div> -->
                    <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample" style="">
                        <div class="card-body">
                            <div class="step_progress">
                                <ul class="step_progress_element" v-if="Object.keys(step_timeline).length">
                                    <!-- Join the Community -->
                                    <li class="step_progress_item">
                                        <span class="step_progress_icon complete_step" v-if="step_timeline.joined_community == true" :class="complete">
                                            <i data-feather="users"></i>
                                        </span>
                                        <span class="step_progress_icon" v-else :class="community_complete==true?'complete_step':''">
                                            <i data-feather="users"></i>
                                        </span>
                                        <div class="progress-label mt-1">
                                            <div class="justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
                                                <h6>Join The Creditfixrr Private Community</h6>
                                            </div>
                                                <div>
                                                    <!-- <p class="">Click the Join button to Join Creditfixrr Private Community.</p> -->
                                                    <button
                                                        class="btn btn-outline-primary btn-sm"
                                                        type="button"
                                                        v-on:click="socilTracker($event,'joined_community',true,'https://www.facebook.com/groups/581643509621324')"
                                                        >
                                                        Join Now
                                                    </button>
                                                </div>
                                        </div>
                                    </li>
                                    <!-- End Join the Community -->
                                    <!-- follow on social media -->
                                    <li class="step_progress_item">
                                        <span class="step_progress_icon complete_step" v-if="step_timeline.socials == true">
                                            <i data-feather="globe"></i>
                                        </span>
                                        <span ref="social_complete" class="step_progress_icon" v-else>
                                            <i data-feather="globe"></i>
                                        </span>
                                        <div class="step_progress_label mt-1">
                                            <div class="justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
                                                <h6 class="mb-50">Follow Our Social Media Channels.</h6>
                                            </div>
                                            <!-- <p class="mb-50">Below are Links to Our Social Media Channels.</p> -->
                                            <button class="btn btn-outline-primary btn-sm" type="button" data-bs-toggle="collapse"
                                                data-bs-target="#collapseExample2" aria-expanded="true" aria-controls="collapseExample2">
                                                Follow Us
                                            </button>
                                            <div class="collapse" id="collapseExample2">
                                                <ul class="list-group list-group-flush mt-1">
                                                    <li class="list-group-item d-flex justify-content-between flex-wrap" style="cursor:pointer" v-on:click="socilTracker($event,'socials',true,'https://www.youtube.com/channel/UCS9gZR8-a7ZDY-x-TWKqv5Q')">
                                                        <span>Youtube</span>
                                                        <i data-feather="youtube" class="cursor-pointer font-medium-2"></i>
                                                    </li>
                                                    <li class="list-group-item d-flex justify-content-between flex-wrap" style="cursor:pointer" v-on:click="socilTracker($event,'socials',true,'https://www.instagram.com/creditfixrr/')">
                                                        <span> Instagram</span>
                                                        <i data-feather="instagram" class="cursor-pointer font-medium-2"></i>
                                                    </li>
                                                    <li class="list-group-item d-flex justify-content-between flex-wrap" style="cursor:pointer" v-on:click="socilTracker($event,'socials',true,'https://twitter.com/creditfixrr')">
                                                        <span> Twitter </span>
                                                        <i data-feather="twitter" class="cursor-pointer font-medium-2"></i>
                                                    </li>
                                                    <!-- https://www.tiktok.com/@creditfixrr?lang=en -->
                                                    <li class="list-group-item d-flex justify-content-between flex-wrap" style="cursor:pointer" v-on:click="socilTracker($event,'socials',true,'https://www.tiktok.com/@creditfixrr?lang=en')">
                                                        <span> Tiktok</span>
                                                        <i data-feather="video" class="cursor-pointer font-medium-2"></i>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                    <!-- end follow on social media -->
                                    <!-- Become an affiliate -->
                                    <li  class="step_progress_item">
                                        <span class="step_progress_icon complete_step" v-if="step_timeline.affiliate == true">
                                            <i data-feather="dollar-sign"></i>
                                        </span>
                                        <span class="step_progress_icon" v-else >
                                            <i data-feather="dollar-sign"></i>
                                        </span>
                                        <div class="step_progress_label mt-1">
                                            <div class="justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
                                                <h6>Become a Creditfixrr Affiliate</h6>
                                            </div>
                                            <!-- <p class="mb-50">Below is the link to affiliate Program</p> -->
                                            <a href="#" target=”_blank” class="btn btn-outline-primary btn-sm" v-on:click="socilTracker($event,'affiliate',true,'https://affiliates.creditfixrr.com/signup')">
                                            Get Paid
                                            </a>
                                        </div>
                                    </li>
                                    <!-- End of become an affiliate -->
                                    <!-- Download  Ebook-->
                                    <li class="step_progress_item">
                                        <span class="step_progress_icon complete_step" v-if="step_timeline.download == true">
                                            <i data-feather="book-open"></i>
                                        </span>
                                        <span class="step_progress_icon" v-else>
                                            <i data-feather="book-open"></i>
                                        </span>
                                        <div class="step_progress_label mt-1">
                                            <div class="justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
                                                <h6 class="mb-50">Download Your “You Are The Creditfixrr” Ebook</h6>
                                            </div>
                                            <div>
                                                <p class="">Coming Soon!</p>
                                                <!-- <button
                                                    class="btn btn-outline-primary btn-sm"
                                                    type="button"
                                                    data-toggle="modal"
                                                    data-target="#dispute_process_modal_video"
                                                    >
                                                    Download
                                                </button> -->
                                            </div>
                                        </div>
                                    </li>
                                    <!-- End of Download  Ebook-->
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import {ref} from 'vue';
import { useLocalizationStore } from '../../stores/LocalizationStore.js'

export default {
    name:'TimelineComponent',
    components: {},
    setup(props) {
        const localizationStore = useLocalizationStore();
        return {
            social_complete:ref(),
            community_complete:ref(),
            complete:ref(),
            localizationStore,
            baseUrl: baseUrl
        }
    },
    data(){
        return {
            timeline: {},
            step_timeline:[],
        }
    },
    created(){
        this.fetchTimeline()
    },
    mounted(){
    },
    methods:{
         fetchTimeline() {
            var h=this;
            axios.get(`${this.baseUrl}/timeline`)
            .then(function (response) {
                h.timeline = response.data.data;
                h.step_timeline = response.data.data.timeline;
            });
        },
        async socilTracker(e,type,value,link){
            e.preventDefault();
            var options = {
                type:type,
                value:value,
            }
            await axios.post(`${this.baseUrl}/timeline/update`,options)
            .then(function (response) {

                if(response.data.data == true){
                    window.open(link, '_blank');
                    setTimeout(()=>{
                        window.location.reload()
                    },1000)
                }
            }).catch(error=>{
                toastr.error(this.localizationStore.translate("Error.wrong.input"),'Error');
            });
        },
    }
};
</script>
<style>
.step_progress_element{
    background: #fff;
    color: #333;
    list-style-type: none;
    border-radius: 10px;
    display: flex;
    padding: 10px 10px;
    position: relative;
    z-index: 10;
}
.step_progress_item{
    padding: 0 20px;
    flex-basis: 0;
    -webkit-box-flex: 1;
    -ms-flex-positive:1;
    flex-grow: 1;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    text-align: center;
    min-width: 170px;
    position: relative;
}
.step_progress_item + .step_progress_item:after{
    content: "";
    position: absolute;
    left: 0;
    top: 19px;
    background: #4b9a5e;
    width: 100%;
    height: 2px;
    transform: translateX(-50%);
    z-index: -10;
}
.step_progress_icon{
    height: 40px;
    width:40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-weight: 600;
    margin: 0 auto;
    position: relative;
    z-index:10;
    color: #4b9a5e;
    background: white;
}
.step_progress_icon:after{
    content: "";
    height: 40px;
    width: 40px;
    background: transparent;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    z-index: 10;
    color: #4b9a5e;
    border: 1px solid #4b9a5e;
}
.step_progress_icon:before{
    content: "";
    height: 10px;
    width: 20px;
    border-left: 3px solid transparent;
    border-bottom: 3px solid transparent;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -60%) rotate(-45deg);
    transform-origin: center center;
}
.step_progress_label{
    font-size: 14px;
    font-weight: 600;
    margin-top: 10px;
}
.uncompleted_step .step_progress_icon:before,
.uncompleted_step ~ .step_progress_item .step_progress_icon:before{
    display: none;
}
.uncompleted_step ~ .step_progress_item .step_progress_icon:after{
    height:10px;
    width:10px;
}
.uncompleted_step ~ .step_progress_item .step_progress_label{
    opacity: 1;
}
.uncompleted_step .step_progress_icon:after{
    background: #fff;
    border: 2px solid #4b9a5e;
}
.uncompleted_step .step_progress_icon{
    color: #4b9a5e;
}
.complete_step {
    background: #4b9a5e;
    color: white;
}
@media only screen and (max-width: 768px) {
    .step_progress_element{
        background: #fff;
        color: #333;
        border-radius: 0;
        display: block;
        position: relative;
        z-index: 0;
        list-style: none;
        margin-bottom: 0;
        margin-left: 1rem;
        padding: 0;
    }
    .step_progress_item{
        padding: 0px;
        flex-basis: 0;
        flex-grow: 0;
        max-width: 100%;
        display: block;
        flex-direction: row;
        text-align: justify;
        min-width: 170px;
        border-left: 1px solid #ebe9f1;
        padding-left: 2.5rem;
        position: relative;
    }
    .step_progress_item + .step_progress_item:after{
        content: "";
        position: absolute;
        left: 0;
        top: 19px;
        background: #4b9a5e;
        width: 0px;
        height: 0px;
        transform: translateX(-50%);
        z-index: -10;
    }
    .step_progress_icon{
        font-weight: 600;
        margin: 0 auto;
        align-items: center;
        background-color: #fff;
        border: 1px solid #4b9a5e;
        border-radius: 50%;
        display: flex;
        height: 1.75rem;
        justify-content: center;
        left: -0.85rem;
        position: absolute;
        text-align: center;
        top: 0;
        width: 1.75rem;
        z-index: 2;
        color:#4b9a5e;
    }
    .step_progress_icon:after{
        content: "";
        height: 0px;
        width: 0px;
        background: transparent;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        border-radius: 50%;
        z-index: -10;
    }
    .step_progress_icon:before{
        content: "";
        height: 0px;
        width: 0px;
        border-left: 3px solid transparent;
        border-bottom: 3px solid transparent;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -60%) rotate(-45deg);
        transform-origin: center center;
    }
    .step_progress_label{
        font-size: 14px;
        font-weight: 600;
        margin-top: 10px;
    }
    .uncompleted_step .step_progress_icon:before,
    .uncompleted_step ~ .step_progress_item .step_progress_icon:before{
        display: none;
    }
    .uncompleted_step ~ .step_progress_item .step_progress_icon:after{
        height:10px;
        width:10px;
    }
    .uncompleted_step ~ .step_progress_item .step_progress_label{
        opacity: 1;
    }
    .uncompleted_step .step_progress_icon:after{
        background: #fff;
        border: 2px solid #4b9a5e;
    }
    .uncompleted_step .step_progress_icon{
        color: #4b9a5e;
    }
    .complete_step{
        background:#4b9a5e;
        color:white;
    }
  }
</style>
